var v1="<div class=\"form-group\" ng-switch=\"vm.selectType\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select multiple=\"multiple\" ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $item }} </ui-select-match> <ui-select-choices repeat=\"tag in vm.tags | filter:$select.search\"> <div>{{ tag }}</div> </ui-select-choices> </ui-select> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaHotelTagSelect/lbaHotelTagSelect.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaHotelTagSelect/lbaHotelTagSelect.html
// module id = 402
// module chunks = 0